import React, {
  ReactNode,
  useRef,
  useEffect,
  ReactElement,
  useCallback,
} from 'react';
import { Flex } from 'rebass/styled-components';

import { Stack } from '../../components';
import {
  SlidePanelBackDrop,
  StyledSlidePanel,
  SlidePanelHeader,
  SlidePanelBody,
  SlidePanelFooter,
  SlidePanelClose,
} from './styles';

import * as Icon from 'assets/icons';

type SlidePanelProps = {
  children: ReactNode;
  title?: string | ReactNode;
  actions?: ReactNode;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  maxWidth?: string;
  open?: boolean;
  onClose?: () => void;
};

function SlidePanel({
  children,
  title,
  actions,
  size,
  maxWidth,
  open,
  onClose,
}: SlidePanelProps): ReactElement {
  const handleKeyDown = useCallback(
    (e: any) => {
      if (open && e.code === 'Escape') onClose && onClose();
    },
    [onClose, open],
  );

  const wrapperRef = useRef<HTMLInputElement>();

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);

  return (
    <>
      <StyledSlidePanel
        size={size}
        maxWidth={maxWidth}
        open={open}
        ref={wrapperRef}
      >
        {title ? <SlidePanelHeader>{title}</SlidePanelHeader> : null}
        <SlidePanelBody>{children}</SlidePanelBody>
        {actions ? (
          <SlidePanelFooter>
            <Flex justifyContent="flex-end" alignItems="center">
              <Stack direction="x" gap={2}>
                {actions}
              </Stack>
            </Flex>
          </SlidePanelFooter>
        ) : null}

        <SlidePanelClose onClick={onClose} open={open}>
          <Icon.X />
        </SlidePanelClose>
      </StyledSlidePanel>
      <SlidePanelBackDrop
        open={open}
        tabIndex={-1}
        onClick={onClose}
      ></SlidePanelBackDrop>
    </>
  );
}

export { SlidePanel };
